import { useQuery } from '@tanstack/react-query';

import { RestrictedGateway } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership-type/:membershipTypeId/restricted-gateways/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    membershipTypeId: string;
}
const queryFn = ({
    parkingId,
    membershipTypeId,
    ...params
}: DTO): Promise<ListResponseSmartParkAPI<RestrictedGateway>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, membershipTypeId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_RESTRICTED_GATEWAYS_RESOURCE, useQueryHook as useListRestrictedGateway };
